var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.proptyp === "checkout"
        ? [
            _vm._l(_vm.returnProp, function(prop) {
              return [
                _c(
                  "div",
                  {
                    key: prop.PropertyId,
                    staticClass: "form-check pl-0",
                    class: { active: prop.value === 1 }
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "d-flex align-items-center",
                        attrs: { for: prop.PropertyId }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "check",
                            class: { checked: prop.value === 1 }
                          },
                          [
                            prop.value === 1
                              ? _c("i", { staticClass: "fa fa-check" })
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "mr-2",
                          attrs: { alt: "customer property", src: _vm.img }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-check flex-fill mb-0" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: prop.value,
                                  expression: "prop.value"
                                }
                              ],
                              staticClass: "form-check-input d-none",
                              attrs: {
                                type: "checkbox",
                                id: prop.PropertyId,
                                "aria-labelledby": "prop.PropertyId"
                              },
                              domProps: {
                                value: prop.value,
                                checked: Array.isArray(prop.value)
                                  ? _vm._i(prop.value, prop.value) > -1
                                  : prop.value
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$a = prop.value,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = prop.value,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            prop,
                                            "value",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            prop,
                                            "value",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(prop, "value", $$c)
                                    }
                                  },
                                  function($event) {
                                    return _vm.customerPropCheck(prop)
                                  }
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "customerPropText",
                              domProps: { innerHTML: _vm._s(_vm.desc) }
                            })
                          ]
                        )
                      ]
                    )
                  ]
                )
              ]
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }